module.exports = __webpack_public_path__ + "static/media/redX.48287667.svg";